import React, { useEffect, useState } from 'react';

function InquiryCount({ dashboardData }) {

  const [data, setData] = useState([]);
  useEffect(() => {
    if (dashboardData) {
      setData(dashboardData);
    }
  }, [dashboardData]);

  return (<>
    <div class="row new-joinee">

      <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div class="card">
          <div class="stat-wrape">
            <div className='detail total'>
              Total Inquiry <span>{data.totalInq ?? 0}</span>
            </div>
            <div className="icon"></div>
          </div>
        </div>
      </div>

      <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div class="card">
          <div class="stat-wrape">
            <div className='detail assign'>
              Assigned Inquiry <span>{data.totalAssignInq ?? 0}</span>
            </div>
            <div className="icon"></div>
          </div>
        </div>
      </div>


      <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div class="card">
          <div class="stat-wrape">
            <div className='detail unassign'>
              Unassigned Inquiry <span>{data.totalNotAssignInq ?? 0}</span>
            </div>
            <div className="icon"></div>
          </div>
        </div>
      </div>

    </div>
  </>)
}

export default InquiryCount
